import { render } from "./dataView.vue?vue&type=template&id=404fd24c"
import script from "./dataView.vue?vue&type=script&lang=js"
export * from "./dataView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__